export const tsxDefaultSource = `// console.log() will be matched by pattern!
// click diff tab to see rewrite.

function tryAstGrep() {
  console.log('matched in metavar!')
}

const multiLineExpression =
  console
   .log({
     also: 'matched',
     multi: 'line',
     expression: 'console.log("you can\\'t trick me!")',
   })

if (true) {
  const notThis = 'console.log("not me")'
} else {
  console.debug('matched by YAML')
}`;

export const tsxDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";
import type TSX from "@ast-grep/napi/lang/tsx";

async function transform(root: SgRoot<TSX>): Promise<string> {
  const rootNode = root.root();

  const nodes = rootNode.findAll({
    rule: {
      any: [
        { pattern: "console.log($ARG)" },
        { pattern: "console.debug($ARG)" },
      ]
    },
  });

  const edits = nodes.map(node => {
    const arg = node.getMatch("ARG").text();
    return node.replace(\`logger.log(\${arg})\`);
  });

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const tsxDefaultConfig = `
# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: replace-console-log
language: tsx
rule:
  any:
    - pattern: console.log($ARG)
    - pattern: console.debug($ARG)
fix:
  logger.log($ARG)
`.trim();
